import { useEffect } from 'react';
import { Alert, AlertIcon, Button, Link, Stack, Text } from '@chakra-ui/react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import LoginWrapper from '../../molecules/LoginWrapper';
import { titleAppend } from '../../../utilities/head';
import { useDispatch, useSelector } from 'react-redux';
import { unsubscribe } from '../../../store/student/actions';
import { ApplicationState } from '../../../store';

const UnsubscribePage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const isLoading = useSelector((state: ApplicationState) => state.ui.isLoading);

  const onOpenLogin = () => navigate('/');

  useEffect(() => {
    const studentID = new URLSearchParams(location.search).get('studentID');
    const email = new URLSearchParams(location.search).get('email');

    if (email && studentID) {
      dispatch(unsubscribe(email, studentID));
    }
  }, [dispatch, location.search]);

  return (
    <LoginWrapper isLoading={isLoading} apiCallsInProgress={[]} heading="Unsubscribed">
      <Helmet>
        <title>Unsubscribed {titleAppend}</title>
      </Helmet>

      <Alert status="success" mb="4">
        <AlertIcon />
        You have been unsubscribed from all reminder emails.
      </Alert>

      <Text>
        If you are no longer enrolling at the university please log into your account and message us or email{' '}
        <Link title={'Contact CAS Shield support'} href={'mailto:contact@cas-shield.com'}>
          contact@cas-shield.com
        </Link>
        .
      </Text>

      <Stack spacing="3">
        <Button size="lg" variant="solid" onClick={onOpenLogin}>
          Log in
        </Button>
      </Stack>
    </LoginWrapper>
  );
};

export default UnsubscribePage;
